<template>
  <div class="sign-out-button" @click.prevent="logout">登出</div>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();

    const router = useRouter();

    //dispatch
    const methods = {
      change_loginData: (payload) => {
        store.dispatch("getLogin/change_loginData", payload);
      },
    };

    const logout = () => {
      var obj = {};
      obj.account = null;
      obj.status = false;
      obj.username = null;
      methods.change_loginData(obj);
      router.push("/");
    };
    return {
      logout,
    };
  },
};
</script>

<style>
.sign-out-button {
  background-color: var(--main-bg-color);
  width: 64px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  color: #eefbf0;
}
</style>
